interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function toast({ title, description, variant }: ToastOptions) {
  // Simple toast using browser alert as fallback
  // In production, replace with a proper toast library
  if (variant === 'destructive') {
    console.error(`[Toast Error] ${title}: ${description}`);
  } else {
    console.log(`[Toast] ${title}: ${description}`);
  }
}
